import axios from 'axios';

export default {
    namespaced: true,
    state: {
        user: null
    },
    mutations: {
        updateCurrentUser(state, user) {
            state.user = user;
        }
    },
    actions: {
        passwordEmail(_, email) {
            return axios
                .post('/auth/password/email', { email: email })
                .catch(console.error);
        },
        passwordReset(_, resetModel) {
            axios.post('/auth/password/reset', resetModel).catch(console.error);
        }
    }
};
